import Emitter from 'emitter-js';

let greeter = new Emitter();

export default greeter